import React from 'react';

const AddIcon = ({ width = 28, height = 28 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15.5" cy="15.5" r="15" fill="#61B8E7" fillOpacity="0.15" stroke="#D3D6DC" />
    <mask
      id="mask0_2863_4240"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="6"
      y="5"
      width="20"
      height="20"
    >
      <rect x="6.5" y="5.5" width="19" height="19" fill="#D9D9D9" stroke="#D3D6DC" />
    </mask>
    <g mask="url(#mask0_2863_4240)">
      <path
        d="M15.179 15.8337V15.8212H15.1665H10.179V14.1795H15.1665H15.179V14.167V9.17949H16.8207V14.167V14.1795H16.8332H21.8207V15.8212H16.8332H16.8207V15.8337V20.8212H15.179V15.8337Z"
        fill="black"
        stroke="#D3D6DC"
        strokeWidth="0.025"
      />
    </g>
  </svg>
);

export default AddIcon;
